/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import SDGSelector from './SDGSelector';
import { InitiativePlain } from '../../types/initiative';
import './style.scss';


interface UpdateMaterialityProps {
  initiative: InitiativePlain;
  isOpen: boolean;
  toggle: () => void;
  handleReload?: () => void;
}


const UpdateMaterialityModal = (props: UpdateMaterialityProps) => {
  const { isOpen, toggle, handleReload, initiative } = props;

  return <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='update-materiality-modal'>
    <ModalHeader toggle={toggle}>Update Material SDGs</ModalHeader>
    <ModalBody>
      <SDGSelector
        handleReload={handleReload}
        toggle={toggle}
        initiative={initiative}
      />
    </ModalBody>
  </Modal>
}

export default UpdateMaterialityModal;
